import script from "./EventsExplorer.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsExplorer.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/eventsExplorer.sass?vue&type=style&index=0&id=75991b48&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75991b48"]])

export default __exports__